import React from "react";
import { connect } from "react-redux";
import { Notifications } from "../../components/Notifications";

class NotificationScreen extends React.Component {
  render() {
    return <Notifications />;
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(NotificationScreen);
